import { Base64 } from 'js-base64';

export function getString(name: string) {
  const item = localStorage.getItem(encrypt(name))
  return item ? decrypt(item) : undefined;
}

export function setString(name: string, value: any) {
  localStorage.setItem(encrypt(name), encrypt(value));
}

export function getObject(name: string) {
  const value = localStorage.getItem(encrypt(name));
  return value ? decrypt(value) : undefined;
}

export function setObject(name: string, value: any) {
  localStorage.setItem(encrypt(name), encrypt(value));
}

export function deleteKey(name: string) {
  localStorage.removeItem(encrypt(name));
}


function encrypt(value: any): string {
  const json = JSON.stringify(value);
  return Base64.encode(json);
}

function decrypt(value: string): any {
  const json = Base64.decode(value);
  return JSON.parse(json);
}